import { render, staticRenderFns } from "./role-detail-modal.vue?vue&type=template&id=6837c720"
import script from "./role-detail-modal.vue?vue&type=script&lang=js"
export * from "./role-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports